export default __webpack_public_path__ + "static/media/paper-load.8b2a274a.svg";